import React, {FC} from 'react';
import {Button, Dialog, Flex, Text, Title} from '@priority-software/priority-style-react';
import {DataTestIds} from '../../constants';
import {texts} from '../../texts';
import styles from './OptimizationCancelDialog.module.scss';
import {OptimizationLoaderState} from '../OptimizationLoader';

export type OptimizationCancelDialogProps = {
    zIndex: number;
    open: boolean;
    setOpen: (value: boolean) => void;
    onCloseProceed: () => void;
    optimizationLoaderState: OptimizationLoaderState;
};

export const OptimizationCancelDialog: FC<OptimizationCancelDialogProps> = ({
    zIndex,
    open,
    setOpen,
    onCloseProceed,
    optimizationLoaderState
}) => {
    return (
        <Dialog
            dataTestId={DataTestIds.optimizationCancelDialogId}
            maskClosable
            isOpen={open}
            onClose={() => setOpen(false)}
            componentClasses={styles.dialog}
            width={520}
            isGradientBorder
            title={
                <Title skin={'h4'} textColor={'primary-700'}>
                    {texts.optimization_cancel_title}
                </Title>
            }
            zIndex={zIndex}
            content={
                <Text textColor={'primary-700'} skin={'paragraph-1'}>
                    {texts.optimization_cancel_explanation}
                </Text>
            }
            footer={
                <Flex componentClasses={styles.footerButtons} justifyContent={'flex-end'}>
                    <Button
                        dataTestId={DataTestIds.cancelButton}
                        wideButton={true}
                        skin={'secondary'}
                        size={'medium'}
                        onClick={() => setOpen(false)}
                    >
                        {texts.cancel}
                    </Button>
                    <Button
                        dataTestId={DataTestIds.runButton}
                        wideButton={true}
                        skin={'primary'}
                        size={'medium'}
                        onClick={() => {
                            if (
                                optimizationLoaderState ===
                                OptimizationLoaderState.VisibleCancellable
                            ) {
                                onCloseProceed();
                            }
                            setOpen(false);
                        }}
                    >
                        {texts.optimization_cancel_close_button}
                    </Button>
                </Flex>
            }
        />
    );
};
